exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question-list{width:100%;display:flex;flex-direction:column;height:100%;gap:16px}.question-item{display:flex;flex-direction:column;gap:12px}.question-body{display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:16px}.question-extra-render{min-height:200px;flex-direction:column;align-items:flex-start;flex:1;gap:24px}", ""]);

// exports
